// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane_xZjkK {
  padding : 40px;
  position: relative;
}

.input_RrjbA {
  width : 250px;
}

.login_BTmLQ {
  margin-top : 20px;
  align-self : center;
}

.warning_S8m5w {
  align-self : center;
  text-align:center;
  min-height: 36px;
}

.line_ysUnU {
  width : inherit;
  border: 1px solid var( --color-Base200 );
}

.seperator_yHEJ9 {
  width : 100%;
  padding-top: var( --size-padSmall );
  padding-bottom: var( --size-padSmall );
}

.separator_fCCwz .text_JZAif {
  color : var( --color-Base200 );
}

.twoFactorContainer_kgP0g {
  width : 100%;
}

.twoFactor_luI0p {
  cursor: pointer;
}

.twoFactor_luI0p .text_JZAif {
  white-space: nowrap;
  text-align: left;
  color : inherit;
}

.identityContainer_CDt7g {
  width : 100%;
}

.loginButtonSeparator_R8ws6 {
  width: 100%;
  border-style: solid;
  border-width: 1px;
  border-bottom-width: 0;
  color: var(--color-base300);
}

.identity_TR00h {
  cursor: pointer;
}

.identity_TR00h .text_JZAif {
  white-space: nowrap;
  text-align: left;
  color : inherit;
}

.radio_Mf4lM {
  border: 1px solid var(--base100, #E7EAEF);
  border-radius: var(--size-padMedium);
  padding: var(--size-padMedium, 8px) var(--size-pasLarge, 16px);
}

.form_FBkd6 {
  width: 100%;
}

.loginPaneFlex_AQxYt {
  width: min-content;
}

.blocker_yA74N {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  background-color: var(--color-base050);
  opacity: 0.8;
}

.character_QW2jY {
  border-radius: var(--size-padSmall);
  border: 1px solid transparent;
  background-color: var(--color-base050);
}

.characterSelected_RCGF_ {
  border: 1px solid var(--color-base400);
  outline: none;
}

.separator_fCCwz {
  width: 100%;
  position: relative;
  padding: var(--size-padMedium) 0;
}

.separator_fCCwz hr {
  border-style: solid;
  border-bottom: none;
  border-color: var(--color-base200);
}

.continueWith_i8okC {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: white;
  padding: 0 var(--size-padLarge);
}

.altLoginButton_xqw9V {
  overflow: hidden;
}

.altLoginButton_xqw9V span {
  flex-grow: 0 !important;
  flex-shrink: 1 !important;
  min-width: 0 !important;
  display: inline-block !important;
  height: 40px;
  vertical-align: middle;
}

.altLoginMethod_mqbBi {
  flex-grow: 1;
  flex-shrink: 0;
  width: auto;
  overflow: hidden;
  align-items: baseline;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
}

.altLoginMethodSmall_nILhY {
  display: block;
  max-width: none !important;
}

.altLoginMethods_f21pQ {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(var(--count-loginMethodColumns, 3),1fr);
  gap: var(--size-padMedium);
  overflow: hidden;
  height: 100px;
}

.altLoginMethods_f21pQ.showMore_qzeD7 {
  height: auto;
  overflow: auto;
}

.qrCode_RocV4 {
  align-self: stretch;
}

.buttons_LSoAi {
  width: 100%;
}

@media only screen and (min-width: 1600px) {
  .loginPaneFlex_AQxYt {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/node_modules/@leverege/api-ui-login/lib/Login.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;EACpC,8DAA8D;AAChE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qEAAqE;EACrE,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".pane {\n  padding : 40px;\n  position: relative;\n}\n\n.input {\n  width : 250px;\n}\n\n.login {\n  margin-top : 20px;\n  align-self : center;\n}\n\n.warning {\n  align-self : center;\n  text-align:center;\n  min-height: 36px;\n}\n\n.line {\n  width : inherit;\n  border: 1px solid var( --color-Base200 );\n}\n\n.seperator {\n  width : 100%;\n  padding-top: var( --size-padSmall );\n  padding-bottom: var( --size-padSmall );\n}\n\n.separator .text {\n  color : var( --color-Base200 );\n}\n\n.twoFactorContainer {\n  width : 100%;\n}\n\n.twoFactor {\n  cursor: pointer;\n}\n\n.twoFactor .text {\n  white-space: nowrap;\n  text-align: left;\n  color : inherit;\n}\n\n.identityContainer {\n  width : 100%;\n}\n\n.loginButtonSeparator {\n  width: 100%;\n  border-style: solid;\n  border-width: 1px;\n  border-bottom-width: 0;\n  color: var(--color-base300);\n}\n\n.identity {\n  cursor: pointer;\n}\n\n.identity .text {\n  white-space: nowrap;\n  text-align: left;\n  color : inherit;\n}\n\n.radio {\n  border: 1px solid var(--base100, #E7EAEF);\n  border-radius: var(--size-padMedium);\n  padding: var(--size-padMedium, 8px) var(--size-pasLarge, 16px);\n}\n\n.form {\n  width: 100%;\n}\n\n.loginPaneFlex {\n  width: min-content;\n}\n\n.blocker {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  background-color: var(--color-base050);\n  opacity: 0.8;\n}\n\n.character {\n  border-radius: var(--size-padSmall);\n  border: 1px solid transparent;\n  background-color: var(--color-base050);\n}\n\n.characterSelected {\n  border: 1px solid var(--color-base400);\n  outline: none;\n}\n\n.separator {\n  width: 100%;\n  position: relative;\n  padding: var(--size-padMedium) 0;\n}\n\n.separator hr {\n  border-style: solid;\n  border-bottom: none;\n  border-color: var(--color-base200);\n}\n\n.continueWith {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%,-50%);\n  background-color: white;\n  padding: 0 var(--size-padLarge);\n}\n\n.altLoginButton {\n  overflow: hidden;\n}\n\n.altLoginButton span {\n  flex-grow: 0 !important;\n  flex-shrink: 1 !important;\n  min-width: 0 !important;\n  display: inline-block !important;\n  height: 40px;\n  vertical-align: middle;\n}\n\n.altLoginMethod {\n  flex-grow: 1;\n  flex-shrink: 0;\n  width: auto;\n  overflow: hidden;\n  align-items: baseline;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  text-overflow: ellipsis;\n}\n\n.altLoginMethodSmall {\n  display: block;\n  max-width: none !important;\n}\n\n.altLoginMethods {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(var(--count-loginMethodColumns, 3),1fr);\n  gap: var(--size-padMedium);\n  overflow: hidden;\n  height: 100px;\n}\n\n.altLoginMethods.showMore {\n  height: auto;\n  overflow: auto;\n}\n\n.qrCode {\n  align-self: stretch;\n}\n\n.buttons {\n  width: 100%;\n}\n\n@media only screen and (min-width: 1600px) {\n  .loginPaneFlex {\n    width: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `pane_xZjkK`,
	"input": `input_RrjbA`,
	"login": `login_BTmLQ`,
	"warning": `warning_S8m5w`,
	"line": `line_ysUnU`,
	"seperator": `seperator_yHEJ9`,
	"separator": `separator_fCCwz`,
	"text": `text_JZAif`,
	"twoFactorContainer": `twoFactorContainer_kgP0g`,
	"twoFactor": `twoFactor_luI0p`,
	"identityContainer": `identityContainer_CDt7g`,
	"loginButtonSeparator": `loginButtonSeparator_R8ws6`,
	"identity": `identity_TR00h`,
	"radio": `radio_Mf4lM`,
	"form": `form_FBkd6`,
	"loginPaneFlex": `loginPaneFlex_AQxYt`,
	"blocker": `blocker_yA74N`,
	"character": `character_QW2jY`,
	"characterSelected": `characterSelected_RCGF_`,
	"continueWith": `continueWith_i8okC`,
	"altLoginButton": `altLoginButton_xqw9V`,
	"altLoginMethod": `altLoginMethod_mqbBi`,
	"altLoginMethodSmall": `altLoginMethodSmall_nILhY`,
	"altLoginMethods": `altLoginMethods_f21pQ`,
	"showMore": `showMore_qzeD7`,
	"qrCode": `qrCode_RocV4`,
	"buttons": `buttons_LSoAi`
};
export default ___CSS_LOADER_EXPORT___;
